/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/handling': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M14 14c-1.968 0-3.393-1.708-4.768-3.359C8.15 9.342 7.032 8 6 8c-2.224 0-3.021 2.227-3.053 2.321a1 1 0 01-1.896-.637C1.102 9.533 2.322 6 6 6c1.968 0 3.392 1.708 4.768 3.359C11.85 10.658 12.968 12 14 12c2.225 0 3.021-2.227 3.053-2.321.18-.52.75-.799 1.268-.623a.999.999 0 01.629 1.261C18.898 10.467 17.678 14 14 14z"/>'
  }
})
